import { NgTemplateOutlet } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  contentChild,
  input,
  TemplateRef,
  ViewEncapsulation,
} from '@angular/core';
import { AutoFocusModule } from 'primeng/autofocus';
import { ButtonModule } from 'primeng/button';
import { RippleModule } from 'primeng/ripple';
import { ButtonPublicApiComponent } from './button-public-api.component';

@Component({
  selector: 'prime-button',
  templateUrl: './prime-button.component.html',
  styleUrls: ['./prime-button.component.scss'],
  imports: [ButtonModule, RippleModule, NgTemplateOutlet, AutoFocusModule],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.p-button-label-normal-weight]': 'hostLabelNormalWeight()',
    '[class.p-button-filter-applied]': 'hostFilterApplied()',
    '[class.p-button-label-truncate]': 'isTruncated()',
    '[class.tw:w-full]': 'fluid',
  },
})
export class PrimeButtonComponent extends ButtonPublicApiComponent {
  readonly isLabelNormalWeight = input(false);
  readonly isButtonAsFilterApplied = input(false);
  readonly pAutoFocus = input(false);
  readonly isHighlighted = input<boolean>(false);
  readonly isTruncated = input<boolean>(false);
  readonly iconTemplate = contentChild<TemplateRef<null> | null>('iconTemplate');
  readonly contentTemplate = contentChild<TemplateRef<null> | null>('contentTemplate');

  hostLabelNormalWeight = computed(() => {
    return this.isLabelNormalWeight();
  });
  hostFilterApplied = computed(() => {
    return this.isButtonAsFilterApplied();
  });
}
